module.exports = require('react/lib/ReactCSSTransitionGroup');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-css-transition-group/index.js
 ** module id = 974
 ** module chunks = 0
 **/